"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const BaseComponent_1 = require("./BaseComponent");
const vasat_1 = require("vasat");
const Constants_1 = require("./Constants");
class AppBaseComponent extends BaseComponent_1.BaseComponent {
    constructor(service, router, snackBar, dialog, applicationEvents) {
        super(router, snackBar, dialog);
        this.service = service;
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.applicationEvents = applicationEvents;
        this.debugAppBase = Constants_1.Constants.debug_off;
        if (this.debugAppBase) {
            console.log('%c app.base.comp [' + this.debugMe + '] %c constructor', Constants_1.Constants._green, Constants_1.Constants._gray);
        }
    }
    // ready / error functions to be overridden
    onReady() { }
    onError(e) { }
    // overwrite ngOnInit() as we do also start with __xs_start(), but we delay the this.init() until after Vasat.service.onReady()
    ngOnInit() {
        if (this.debugAppBase) {
            console.log('%c app.base.comp [' + this.debugMe + '] %c ngOnInit()', Constants_1.Constants._green, Constants_1.Constants._gray);
        }
        // set up unique identifiers and event handlers
        this.__xs_start();
        if (this.service.V.localSession()) {
            this.service.onReady().subscribe(s => {
                this.init();
                this.onReady();
            }, e => {
                if (e instanceof vasat_1.VasatError) {
                    // TODO
                }
                this.onError(e);
            });
        }
        else {
            // this.router.navigateByUrl(this.routes.AUTH + '?prevpage=' + this.router.routerState.snapshot.url)
            this.router.navigateByUrl(this.routes.AUTH);
        }
    }
    ngOnDestroy() {
        // call on mama to clean up subscriptions
        super.ngOnDestroy();
        if (this.debugAppBase) {
            console.log('%c app.base.comp [' + this.debugMe + '] %c ngOnDestroy()', Constants_1.Constants._green, Constants_1.Constants._gray);
        }
        this.destroy();
    }
    // this doesn't seem to ever be used? (@alex)
    setProp(model, propName, value) {
        //console.log("ENTER prop: " + propName + " value: " + value)
        //console.log(JSON.stringify(model.props))
        // Initialize props if undefinned
        if (!model.props)
            model.props = {};
        model.props[propName] = value;
        //console.log(JSON.stringify(model.props))
        this.loading = true;
        model.saveObservable().subscribe(res => {
            this.loading = false;
        }, err => {
            this.loading = false;
            this.openSnackBarError(err.status + ' ' + err.message);
        });
    }
}
exports.AppBaseComponent = AppBaseComponent;
